import { Fragment, useContext, useState } from 'react';
import { addGlue, updateGlue, deleteGlue, stationOptions, glueDescription, glueSourceDisplay, glueSourceOptions } from '../services/glueService';
import { Button } from 'react-bootstrap'
import Icons from './common/Icons';
import ProtectedComponent from './common/ProtectedComponent';
import { AuthContext } from './Login/AuthContext';
import { DatabaseContext } from './DatabaseContext';

import { boolToIcon, dateYYYYMMMDD } from '../services/commonParse';
import { HGCFormRowBool, HGCFormRowDate, HGCFormRowSelect } from './common/SimpleForm';

import { TableViewAdd, defaultAdd, defaultResetAdd } from './common/TableViewAdd';
import { TableViewEdit, defaultReset, defaultEdit } from './common/TableViewEdit';
import PaginateTable, { BooleanFilter, CategoryFilter } from './common/TableDisplay.jsx';
import { findTableRow } from '../services/tableUtils';

const GlueColumns = () => [
  { Header: 'id', Cell: GlueIDCell, },
  { Header: 'Manufacturer', Cell: (glue) => glueSourceDisplay(glue.source), Filter: CategoryFilter((glue) => glue.source) },
  { Header: 'In stock', Cell: (glue) => boolToIcon(glue.in_stock), Filter: BooleanFilter(((glue) => glue.in_stock), "true") },
]

const GlueIDCell = (glue) => {
  const { user } = useContext(AuthContext);

  // For showing single items
  const [showEdit, setShowEdit] = useState(false);
  const { glueList, updateGlueList } = useContext(DatabaseContext);
  const removeAction = async () => { await deleteGlue(glue.id); updateGlueList(); }

  return <Fragment>
    {glueDescription(glueList, glue.id)}
    <Button variant='light' size='sm' onClick={() => { setShowEdit(true) }}>{Icons.edit}</Button>
    {user.role === "admin" && <Button variant='light' size='sm' onClick={removeAction}>{Icons.remove}</Button>}
    {showEdit && <GlueEdit id={glue.id} showState={[showEdit, setShowEdit]} />}
  </Fragment>
}

const GlueEdit = ({ id, showState }) => {
  const [, setShow] = showState
  const { glueList, updateGlueList } = useContext(DatabaseContext);
  const [invalid,] = useState(""); // Setting as constant false for now
  const origData = findTableRow(glueList, (glue) => Number(glue.id) === Number(id));
  // Creating all items related to the display form
  const form = {
    "epoxy_expiry_date": useState(new Date(origData.epoxy_expiry_date)),
    "source": useState(origData.source),
    "station": useState(origData.station),
    "in_stock": useState(origData.in_stock)
  }
  const error = {
    "source": useState(""),
    "station": useState(""),
  }

  const resetAction = defaultReset(form, origData);
  const editAction = defaultEdit(id, form, updateGlue, updateGlueList, setShow)

  return <TableViewEdit title={`Edit glue [${id}]`} showState={showState} resetAction={resetAction} editAction={editAction} invalid={invalid}>
    <HGCFormRowDate label="Expiry date" dataState={form["epoxy_expiry_date"]} />
    <HGCFormRowSelect label="Manufacturer" dataState={form["source"]} errorState={error["source"]} options={glueSourceOptions} allowNull={false} />
    <HGCFormRowSelect label="Station" dataState={form["station"]} errorState={error["station"]} options={stationOptions} allowNull={false} />
    <HGCFormRowBool label="In stock" dataState={form["in_stock"]} />
  </TableViewEdit>
}


const GlueAdd = ({ showState }) => {
  const [, setShowState] = showState

  // Getting the item required for the incrementation method
  const { updateGlueList } = useContext(DatabaseContext);
  const [invalid,] = useState("") // Setting as constant false for now
  const form = {
    "epoxy_expiry_date": useState(new Date()),
    "source": useState(null),
    "station": useState(null),
    "in_stock": useState(true),
  }
  const error = {
    "source": useState(""),
    "station": useState(""),
  }

  const resetAction = defaultResetAdd(form, { 'expoy_expiry_date': () => new Date() })
  const addAction = defaultAdd(form, addGlue, updateGlueList, resetAction, setShowState);

  return <TableViewAdd title="Add new Glue entry" showState={showState} addAction={addAction} invalid={invalid}>
    <HGCFormRowDate label="Expiry date" dataState={form["epoxy_expiry_date"]} />
    <HGCFormRowSelect label="Manufacturer" dataState={form["source"]} errorState={error["source"]} options={glueSourceOptions} allowNull={false} />
    <HGCFormRowSelect label="Station" dataState={form["station"]} errorState={error["station"]} options={stationOptions} allowNull={false} />
    <HGCFormRowBool label="In stock" dataState={form["in_stock"]} />
  </TableViewAdd>
}

export const GlueList = () => {
  const { glueList } = useContext(DatabaseContext);
  const [showAdd, setShowAdd] = useState(false);

  return <ProtectedComponent>
    <Button onClick={() => { setShowAdd(true) }}>Add glue</Button>
    <GlueAdd showState={[showAdd, setShowAdd]} />
    <hr />
    <PaginateTable tableData={glueList} columnLayout={GlueColumns()} />
  </ProtectedComponent>
}

export default GlueList;
